import { render, staticRenderFns } from "./PersonalDataCard.vue?vue&type=template&id=4ffed422&scoped=true&"
import script from "./PersonalDataCard.vue?vue&type=script&lang=js&"
export * from "./PersonalDataCard.vue?vue&type=script&lang=js&"
import style0 from "./PersonalDataCard.vue?vue&type=style&index=0&id=4ffed422&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffed422",
  null
  
)

export default component.exports